import { useNavigate } from "react-router-dom";
import { useLang } from "../../contexts/LangContext";
import { useLogSession } from "../../contexts/LogSessionContext";

export default function AddAnotherDay() {
  const { t } = useLang();
  const navigate = useNavigate();
  const {
    mode,
    person,
    setcurrentDayRecord,
    setcurrentMealRecord,
    setNewFishItem,
    exitFallback,
  } = useLogSession();

  const handleYes = () => {
    // Reset session state
    setcurrentDayRecord(null);
    setcurrentMealRecord(null);
    setNewFishItem(null);

    if (mode === "survey") {
      navigate(`/survey/new/${person.id}`);
    } else {
      navigate(`/user/new-log`);
    }
  };

  const handleNo = () => {
    navigate(
      exitFallback || (mode === "survey" ? "/survey/person-list" : "/user"),
      { replace: true }
    );
  };

  return (
    <div className="flex flex-col items-center justify-center gap-10 mt-12 text-center px-scr">
      <h1 className="text-3xl font-bold text-rose-700">
        {
          t(
            "addAnotherDay_Heading"
          ) /* e.g., "Do you want to log for another day?" */
        }
      </h1>

      <div className="flex flex-col gap-4 w-full max-w-xs">
        <button
          type="button"
          onClick={handleYes}
          className="w-full button-base button-bg-grad-green flex items-center justify-center gap-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="size-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="m4.5 12.75 6 6 9-13.5"
            />
          </svg>
          <span>{t("addAnotherDay_Yes")}</span>
        </button>

        <button
          type="button"
          onClick={handleNo}
          className="w-full button-base button-bg-grad-2 flex items-center justify-center gap-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="size-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18 18 6M6 6l12 12"
            />
          </svg>
          <span>{t("addAnotherDay_No")}</span>
        </button>
      </div>
    </div>
  );
}
